<q-boFind *ngIf="modeBo == modeBoEnum.Find" [input]="item"></q-boFind>

<ng-container *ngIf="modeBo == modeBoEnum.Edit" [ngSwitch]="templateName">
  <!--#region controls templates -->
  <!--Zoom-->
  <ng-container *ngSwitchCase="'zoom'">
    <div class="input-group input-group-sm">
      <div class="col q-light-grey px-0 mx-0 d-flex" [style.height]="'24px'" [style.width]="item.MainElementList[0].Value != '' ? 'calc(100% - 40px)' : 'calc(100% - 0px)'">
        <div class="px-0 mx-0 h-100">
          <a *ngIf="item.MainElementList[0].Value != ''" class="q-c-light-black" [attr.href]="item.MainElementList[0].Value" onclick="window.open(this.href); return false;" [title]="item.MainElementList[0].Value">Démarrer la réunion</a>
          <div *ngIf="item.MainElementList[0].Value == ''" class="invisible">_</div>
        </div>

        <!--d-flex-->
        <button *ngIf="item.MainElementList.length > 1" id="BtnZoom" [ngClass]="{'d-none': !model?.ShowZoomButton}" class="zoom-button btn btn-outline-secondary q-input-icon h-100 ml-auto pr-1" style="padding:5px;" (click)="navig(item.MainElementList[1])" [disabled]="!model.IdDonneeFils || model.IdDonneeFils === '0'"><i [ngClass]="item.MainElementList[1].Src"></i></button>
      </div>
      <button *ngIf="item.MainElementList[0].Value != ''" class="col-auto q-btn q-white p-0 m-0  ml-auto" style="height:24px;min-height: 24px;line-height: initial;"
              title="copier le lien"
              (click)="copyInClipboard(item.MainElementList[0].Value)">
        <i class="fas fa-copy fa-xs"></i>
      </button>
    </div>
    <!--<div class="row m-0">
      <ng-container *ngIf="view !== 'read'">
        <div class="row q-light-grey px-0 mx-0" [style.height]="'24px'" [style.width]="item.MainElementList[0].Value != '' ? 'calc(100% - 40px)' : 'calc(100% - 0px)'">
          <div class="px-0 mx-0 h-100">
            <a *ngIf="item.MainElementList[0].Value != ''" class="q-c-light-black" [attr.href]="item.MainElementList[0].Value" onclick="window.open(this.href); return false;" [title]="item.MainElementList[0].Value">Démarrer la réunion</a>
            <div *ngIf="item.MainElementList[0].Value == ''" class="invisible">_</div>
          </div>

          <button *ngIf="item.MainElementList.length > 1" id="BtnZoom" class="d-none zoom-button btn btn-outline-secondary q-input-icon h-100 ml-auto" (click)="navig(item.MainElementList[1])" [disabled]="!model.IdDonneeFils || model.IdDonneeFils === '0'"><i [ngClass]="item.MainElementList[1].Src"></i></button>
        </div>
        <button *ngIf="item.MainElementList[0].Value != ''" class="q-btn q-white p-0 m-0  ml-auto" style="height:24px;min-height: 24px;line-height: initial;"
                title="copier le lien"
                (click)="copyInClipboard(item.MainElementList[0].Value)">
          <i class="fas fa-copy fa-xs"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="view === 'read'">
        <a *ngIf="item.MainElementList[0].Value != ''" class="q-c-light-black" [attr.href]="item.MainElementList[0].Value" onclick="window.open(this.href); return false;" [title]="item.MainElementList[0].Value">Rejoindre la réunion {{item.MainElementList[0].Value}}</a>
      </ng-container>
    </div>-->
  </ng-container>

  <!--checkbox-->
  <ng-container *ngSwitchCase="'checkbox'">
    <div id="switch" class="checkbox checbox-switch switch-primary">
      <label>
        <input [id]="item.MainElementList[0].ID" type="checkbox" [checked]="item.MainElementList[0].Value === '0'? false : true" (change)="checkChange($event, item)" [disabled]="item.MainElementList[0].Disabled" />
        <span></span>
      </label>
    </div>
  </ng-container>

  <!--#region text-->
  <ng-container *ngSwitchCase="'text'">
    <div class="input-group input-group-sm">
      <input [id]="getId(item)" [attr.type]="item.MainElementList[0].Type" class="col q-input-border q-bo" aria-label="Small" attr.aria-describedby="{{getId(item)}}-btn"
             [disabled]="item.MainElementList[0].Disabled"
             [(ngModel)]="item.MainElementList[0].Value"
             [ngClass]="setClass(item)">
      <div *ngFor="let button of item?.MainElementList?.slice(1)" class="input-group-append">
        <button *ngIf="button.Type === 'BUTTON'" class="q-btn q-bo q-main p-0" (click)="navig(button, item);"
                [title]="button?.Tooltip ? button?.Tooltip : ''">
          <i class="{{button.Src}}"></i>
        </button>
      </div>
    </div>
    <!--<ng-container [ngTemplateOutlet]="item.MainElementList.length > 1?inputwithbutton:witoutbutton" [ngTemplateOutletContext]="{input:input}"></ng-container>-->
  </ng-container>

  <!--<ng-container *ngSwitchCase="'witoutbutton'" let-input='input'>
    <input [id]="getId(input)" [attr.type]="input.MainElementList[0].Type" class="col q-input-border q-bo"
           [disabled]="isDisabled(input)"
           [(ngModel)]="input.MainElementList[0].Value"
           [ngClass]="setClass(input)">
  </ng-container>-->
  <!--<ng-container *ngSwitchCase="'inputwithbutton'" let-input='input'>
    <div class="input-group input-group-sm">
      <input [id]="getId(input)" [attr.type]="input.MainElementList[0].Type" class="col q-input-border q-bo" aria-label="Small" attr.aria-describedby="{{getId(input)}}-btn"
             [disabled]="isDisabled(input)"
             [(ngModel)]="input.MainElementList[0].Value"
             [ngClass]="setClass(input)">
      <div *ngFor="let button of input.MainElementList.slice(1)" class="input-group-append">
        <button *ngIf="button.Type === 'BUTTON'" class="q-btn q-bo q-main p-0" (click)="navig(button, input);"
                [title]="button.Tooltip">
          <i class="{{button.Src}}"></i>
        </button>
      </div>
    </div>
  </ng-container>-->
  <!--#endregion text-->
  <!--#region select-->
  <ng-container *ngSwitchCase="'select'">
    <div class="input-group input-group-sm">
      <select [id]="getId(item)" class="col q-main-select q-bo-select q-bo-wrap" [ngClass]="setClass(item)" [disabled]="item.MainElementList[0].Disabled" [required]="item.MainElementList[0].Required" (change)="selectChange($event.target.value, item)">
        <option *ngFor="let option of item.MainElementList[0].SelectOptionsList" [title]="option?.Tooltip ? option?.Tooltip : ''" [value]="option.Value" [selected]="option.Selected">{{option.Text}}</option>
      </select>
      <div *ngFor="let button of item?.MainElementList?.slice(1)" class="input-group-append">
        <button *ngIf="button.Type === 'BUTTON'" class="btn btn-outline-secondary q-bo-inputbtn q-bo-wrap" (click)="navig(button, item)"
                [title]="button.Tooltip">
          <i class="{{button.Src}}"></i>
        </button>
      </div>
    </div>
    <!--<ng-container [ngTemplateOutlet]="input.MainElementList.length > 1 ? selectwithbutton : selectwitoutbutton" [ngTemplateOutletContext]="{input:input}"></ng-container>-->
  </ng-container>

  <!--<ng-container *ngSwitchCase="'selectwitoutbutton'" let-input='input'>
    <select [id]="getId(input)" class="q-main-select q-bo-select q-bo-wrap" [disabled]="isDisabled(input)" [required]="input.MainElementList[0].Required" (change)="selectChange($event.target.value, input)">
      <option *ngFor="let option of input.MainElementList[0].SelectOptionsList" [title]="option.Tooltip" [value]="option.Value" [selected]="option.Selected">{{option.Text}}</option>
    </select>
  </ng-container>

  <ng-container *ngSwitchCase="'selectwithbutton'" let-input='input'>
    <div class="input-group input-group-sm">
      <select [id]="getId(input)" class="q-main-select q-bo-select q-bo-wrap" [disabled]="isDisabled(input)" [required]="input.MainElementList[0].Required" (change)="selectChange($event.target.value, input)">
        <option *ngFor="let option of input.MainElementList[0].SelectOptionsList" [title]="option.Tooltip" [value]="option.Value" [selected]="option.Selected">{{option.Text}}</option>
      </select>
      <div *ngFor="let button of input?.MainElementList?.slice(1)" class="input-group-append">
        <button *ngIf="button.Type === 'BUTTON'" class="btn btn-outline-secondary q-bo-inputbtn q-bo-wrap" (click)="navig(button, input)"
                [title]="button.Tooltip">
          <i class="{{button.Src}}"></i>
        </button>
      </div>
    </div>
  </ng-container>-->
  <!--#endregion select-->
  <!--#region textarea-->
  <ng-container *ngSwitchCase="'textarea'">
    <textarea [id]="getId(item)" class="col q-input-border q-bo" [disabled]="item.MainElementList[0].Disabled" [style.Height.px]="item.MainElementList[0].Height"
              [ngClass]="setClass(item)"
              [(ngModel)]="item.MainElementList[0].Value" wrap="hard">{{item.MainElementList[0].Value}}</textarea>
  </ng-container>
  <!--#endregion textarea-->
  <!--#region images -->
  <ng-container *ngSwitchCase="'image'">
    <div class="row no-gutters" [id]="item.MainElementList[0].ID">
      <div [ngClass]="[!item.MainElementList[0].Disabled ? 'col-6' :'col-12']">
        <img class="q-bo-image q-bo-wrap" [src]="item.MainElementList[0].Src" />
      </div>
      <div *ngIf="!item.MainElementList[0].Disabled" class="col-6">
        <div class="container-fluid" style="margin-top:45px;">
          <div class="row no-gutters">
            <div class="col-12">
              <label class="position-absolute file h-100" for="file">
                <input class="h-100 w-100" type="file" accept=".gif,.jpg,.jpeg,.png" (change)="onChangeImage($event, item)" />
              </label>
              <button class="btn btn-outline-secondary q-input-icon img-upload-btn">
                Charger&nbsp;<i class="far fa-image"></i>
              </button>
            </div>
            <div class="col-12 mt-2">
              <button class="btn btn-outline-danger q-input-icon img-remove-btn" (click)="deleteFile(item)">
                Supprimer&nbsp;<i class="far fa-trash-alt"></i>
              </button>

            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <!--#endregion images -->
  <!--#region datepicker -->
  <ng-container *ngSwitchCase="'datepicker'">
    <!--<q-datepicker [model]="model" [input]="input" [view]="view" class="w-100"></q-datepicker>-->
    <q-datepicker [model]="model" [input]="item" class="w-100" (navig)="navig($event, item);"></q-datepicker>
  </ng-container>
  <!--#endregion datepicker -->
  <!--#region postal code -->
  <ng-container *ngSwitchCase="'postalcode'">
    <q-codepostal [input]="item" (navig)="navig($event, item);"></q-codepostal>
  </ng-container>
  <!--#endregion postal code -->
  <!--#region ackkey -->
  <ng-container *ngSwitchCase="'ackkey'">
    <q-ackkey [(input)]="item" (inputChange)="OnItemChange($event)"></q-ackkey>
  </ng-container>
  <!--#endregion postal code -->
  <!--timer-->
  <ng-container *ngSwitchCase="'timer'">
    <q-timer [input]="item"></q-timer>
  </ng-container>

  <!-- check com -->
  <ng-container *ngSwitchCase="'checkcom'">
    <q-checkboxselect [input]="item" [parent]="parent" class="w-100 input-group d-flex flex-row justify-content-between"></q-checkboxselect>
  </ng-container>

  <!--search select -->
  <ng-container *ngSwitchCase="'searchselect'">
    <q-searchselect [input]="item" (setInput)="navigFromChildTag($event)" class="w-100"></q-searchselect>
  </ng-container>

  <!-- couple -->
  <ng-container *ngSwitchCase="'couple'">
    <q-couple [input]="item" class="w-100"></q-couple>
  </ng-container>

  <!-- aspx -->
  <ng-container *ngSwitchCase="'aspx'">
    <q-aspx [input]="item" (setInput)="navigFromChildTag($event)" class="w-100"></q-aspx>
  </ng-container>

  <!-- access doc/file -->
  <ng-container *ngSwitchCase="'accessDocAndFile'">
    <q-accessDocAndFile [model]="model" [(input)]="item" (inputChange)="OnItemChange($event)" (setInput)="navigFromChildTag($event)" class="w-100"></q-accessDocAndFile>
  </ng-container>

  <!--#region email -->
  <ng-container *ngSwitchCase="'email'">
    <q-email [input]="item"></q-email>
  </ng-container>
  <!--#endregion email -->
  <!-- image select -->
  <ng-container *ngSwitchCase="'imageselect'">
    <q-image-select [model]="model" [input]="item" [parent]="parent" class="w-100"></q-image-select>
  </ng-container>

  <!-- text historique -->
  <ng-container *ngSwitchCase="'texthistorique'">
    <q-texthistorique [input]="item" class="w-100"></q-texthistorique>
  </ng-container>

  <!-- cabinet -->
  <ng-container *ngSwitchCase="'cabinet'">
    <q-cabinet [input]="item" class="w-100"></q-cabinet>
  </ng-container>

  <!-- cabinet -->
  <ng-container *ngSwitchCase="'radio-bouton'">
    <q-radio-bouton [input]="item" class="w-100"></q-radio-bouton>
  </ng-container>

  <!-- insee -->
  <ng-container *ngSwitchCase="'insee'">
    <q-insee [input]="item" [model]="model" class="w-100"></q-insee>
  </ng-container>


  <!-- gocardlessMandate -->
  <ng-container *ngSwitchCase="'gocardlessMandate'">
    <q-mandat-gocardless [input]="item" [model]="model" class="w-100"></q-mandat-gocardless>
  </ng-container>

  <!-- video zoom -->
  <ng-container *ngSwitchCase="'videoZoom'">
    <q-video-zoom [input]="item" [idEvent]="model.IdDonneeFils" class="w-100"></q-video-zoom>
  </ng-container>

  <ng-container *ngSwitchCase="'textList'">
    <q-text-list [input]="item" class="w-100"></q-text-list>
  </ng-container>
  <!-- input avec bouton de recherche dans une grid-->
  <ng-container *ngSwitchCase="'searchAgGrid'">
    <q-search-ag-grid [(input)]="item" [codeBo]="model.IdentBO" [model]="model" (navig)="navig($event, item);" class="w-100"></q-search-ag-grid>
  </ng-container>

  <!-- rum sepa-->
  <ng-container *ngSwitchCase="'rumSepa'">
    <q-rum-sepa [(input)]="item" class="w-100"></q-rum-sepa>
  </ng-container>

  <!-- chapitres elearning -->
  <ng-container *ngSwitchCase="'elearningChapters'">
    <q-elearning-chapters [input]="item" class="w-100"></q-elearning-chapters>
  </ng-container>

  <!-- text editor-->
  <ng-container *ngSwitchCase="'textEditor'">
    <q-text-editor [input]="item" class="w-100"></q-text-editor>
  </ng-container>

  <!-- modal d'administration d'accès au portail'-->
  <ng-container *ngSwitchCase="'acesport'">
    <q-admin-acces-portail [(input)]="item" [model]="model" (navig)="navig($event, item);" class="w-100"></q-admin-acces-portail>
  </ng-container>

  <!-- numering numering-->
  <ng-container *ngSwitchCase="'numering'">
    <q-numering [input]="item" [model]="model" (navig)="navig($event, item);" class="w-100"></q-numering>
  </ng-container>
  <ng-container *ngSwitchCase="'inputMyCompanyFiles'">
    <q-input-my-company-files [input]="item" [model]="model" (navig)="navig($event, item);" class="w-100"></q-input-my-company-files>
  </ng-container>

  <!-- checkboxlistgroup -->
  <ng-container *ngSwitchCase="'checkboxlistgroup'">
    <div class="checkboxList" [id]="item.MainElementList[0].ID" *ngIf="item.MainLabel.Visible">
      <div class="form-check" *ngFor="let check of item.MainElementList[0].SelectOptionsList; let i = index">
        <label class="form-check-label" for="check{{check.Value}}">
          <input [disabled]="item.MainElementList[0].Disabled" type="checkbox" class="form-check-input" id="check{{check.Value}}" name="option{{check.Value}}" value="something" [checked]="check.Selected" (change)="check.Selected = !check.Selected">{{check.Text}}
        </label>
      </div>
    </div>
  </ng-container>

  <!-- Reseaux Sociaux -->
  <ng-container *ngSwitchCase="'socialNetwork'">
    <div class="input-group input-group-sm">
      <div *ngFor="let button of item.MainElementList.slice(1)" class="input-group-append">
        <button *ngIf="button.Type === 'BUTTON'"
                class="q-circle-social"
                (click)="navigReseauxSociaux(button)"
                [id]="button.ID"
                [title]="button.ToolTip">
          <i class="{{button.Src}}"></i>
        </button>
      </div>
    </div>
  </ng-container>
</ng-container>



